import React, { useState } from 'react';
import HomePage from './pages/HomePage';
import MenuPage from './pages/MenuPage';
import QoplaOrderPage from './pages/QoplaOrderPage';
import EventsPage from './pages/EventsPage'; // Assuming you want to keep this page logic
import QoplaMenuPage from './pages/QoplaMenuPage';

function App() {
  // --- Ikon Komponenter (Inline SVG) ---
// Ingen ändring här


  // State to manage the current page
  const [currentPage, setCurrentPage] = useState('home'); // 'home', 'menu', 'onlineOrder', or 'easterEgg'

  // Function to change the current page
  const navigateTo = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0); // Scroll to top on page change
  };

  return (
    <div className="App bg-orange-50 min-h-screen font-sans">
      {/* Conditionally render page based on state */}
      {currentPage === 'home' && <HomePage navigateTo={navigateTo} />}
      {currentPage === 'menu' && <MenuPage navigateTo={navigateTo} />}
      {currentPage === 'onlineOrder' && <QoplaOrderPage navigateTo={navigateTo} />}
      {currentPage === 'onlineMenu' && <QoplaMenuPage navigateTo={navigateTo} />}
      {currentPage === 'events' && <EventsPage navigateTo={navigateTo} />} {/* Render EventsPage for 'easterEgg' */}
    </div>
  );
}

export default App;
